import type { ComponentProps } from 'react';
import { forwardRef } from 'react';
import { styled } from 'styled-components';

import Button from '../../Controls/Button/index.tsx';

const TheadButtonContainer = styled.div<{ $active?: boolean }>`
  display: inline-flex;

  button {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    position: relative;
    border: 2px solid ${({ theme }) => theme.colors.grey00_1};
  }

  button:after {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }

  button:not([disabled]) {
    ${({ theme }) => theme.shadows.shadowTuna}
  }

  button svg {
    transition: 0.16s;
    transform: ${({ $active }) => $active && 'rotateX(180deg)'};
  }
`;

type TheadButtonProps = ComponentProps<typeof Button> & {
  active?: boolean;
};

export const TheadButton = forwardRef<HTMLButtonElement, TheadButtonProps>(function TheadButton({ active, ...props }, ref) {
  return (
    <TheadButtonContainer $active={active}>
      <Button ref={ref} {...props} />
    </TheadButtonContainer>
  );
});
